import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../../api/authService';
import { setToken, setUser } from '../../Utility/Utility';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    email: '',
    phone: '',
    password: ''
  });

  const buildUserInfoFromAuth = (rawUser) => {
    if (!rawUser) return null;
    const perms = {
      allowedPages: rawUser.allowedPages || [],
      readOnly: rawUser.readOnly !== undefined ? rawUser.readOnly : false,
      actionPermissions: rawUser.actionPermissions || {},
      customPermissions: rawUser.customPermissions || {},
      tableActions: rawUser.tableActions || {}
    };
    return {
      id: rawUser.id,
      name: rawUser.name,
      email: rawUser.email,
      admin: rawUser.admin,
      role: rawUser.role,
      roleTemplateId: rawUser.roleTemplateId || '',
      roleTemplateName: rawUser.roleTemplateName || '',
      companyName: rawUser.companyName || '',
      loginType: rawUser.loginType,
      permissions: perms
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await authService.register(formData);
      if (res.success && res.token) {
        setToken(res.token);
        if (res.user) {
          const userInfo = buildUserInfoFromAuth(res.user);
          if (userInfo) setUser(userInfo);
        }
        navigate('/', { replace: true });
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-4">
      <div className="card border-0 shadow-sm" style={{ maxWidth: '520px', width: '100%' }}>
        <div className="card-body p-4 p-md-5">
          <h3 className="fw-700 mb-2">Create Subscription Workspace</h3>
          <p className="text-muted mb-4">Set up your own billing SaaS instance with customer, sales, invoice, API, and iframe access.</p>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Owner Name</label>
                <input className="form-control" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">Company Name</label>
                <input className="form-control" value={formData.companyName} onChange={(e) => setFormData({ ...formData, companyName: e.target.value })} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Email</label>
                <input className="form-control" type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">Phone</label>
                <input className="form-control" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
              </div>
              <div className="col-12">
                <label className="form-label">Password</label>
                <input className="form-control" type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} required />
              </div>
            </div>
            <button className="btn btn-primary w-100 mt-4" disabled={loading}>
              {loading ? 'Creating workspace...' : 'Register'}
            </button>
          </form>
          <div className="text-center mt-3">
            <span className="text-muted">Already have an account? </span>
            <Link to="/login">Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
